// Importa todas las imágenes explícitamente
import img1 from '../images/1366/imagen-exterior-mimina-1.webp';
import img2 from '../images/1366/imagen-exterior-mimina-2.webp';
import img3 from '../images/1366/imagen-exterior-mimina-3.webp';
import img4 from '../images/1366/imagen-exterior-mimina-4.webp';
import img5 from '../images/1366/imagen-exterior-mimina-5.webp';
import img6 from '../images/1366/imagen-exterior-mimina-6.webp';
import img7 from '../images/1366/imagen-exterior-mimina-7.webp';
import img8 from '../images/1366/imagen-exterior-mimina-8.webp';
import img9 from '../images/1366/imagen-pasillos-mimina-1.webp';

// Galerías de imágenes
const galleries = [
  {
    id: 'galeria1',
    title: 'Exterior',
    icon: 'fas fa-tree',
    images: [
      { src: img1, alt: 'Vista del jardín principal de Mimina', title: 'Jardín Principal' },
      { src: img2, alt: 'Sala de estar para residentes', title: 'Sala de Estar' },
      { src: img3, alt: 'Habitaciones confortables para los residentes', title: 'Habitaciones' },
      { src: img4, alt: 'Vista del jardín principal de Mimina', title: 'Jardín Principal' },
      { src: img5, alt: 'Sala de estar para residentes', title: 'Sala de Estar' },
      { src: img6, alt: 'Habitaciones confortables para los residentes', title: 'Habitaciones' },
      { src: img7, alt: 'Habitaciones confortables para los residentes', title: 'Habitaciones' },
      { src: img8, alt: 'Habitaciones confortables para los residentes', title: 'Habitaciones' },
      { src: img9, alt: 'Habitaciones confortables para los residentes', title: 'Habitaciones' },
    ],
  },
  {
    id: 'galeria2',
    title: 'Espacios comunes',
    icon: 'fas fa-couch',
    images: [
      { src: img1, alt: 'Vista del jardín principal de Mimina', title: 'Jardín Principal' },
      { src: img2, alt: 'Sala de estar para residentes', title: 'Sala de Estar' },
      { src: img3, alt: 'Habitaciones confortables para los residentes', title: 'Habitaciones' },
      { src: img4, alt: 'Vista del jardín principal de Mimina', title: 'Jardín Principal' },
      { src: img5, alt: 'Sala de estar para residentes', title: 'Sala de Estar' },
      { src: img6, alt: 'Habitaciones confortables para los residentes', title: 'Habitaciones' },
      { src: img7, alt: 'Habitaciones confortables para los residentes', title: 'Habitaciones' },
      { src: img8, alt: 'Habitaciones confortables para los residentes', title: 'Habitaciones' },
      { src: img9, alt: 'Habitaciones confortables para los residentes', title: 'Habitaciones' },
    ],
  },
  {
    id: 'galeria3',
    title: 'Habitaciones',
    icon: 'fas fa-bed',
    images: [
      { src: img1, alt: 'Vista del jardín principal de Mimina', title: 'Jardín Principal' },
      { src: img2, alt: 'Sala de estar para residentes', title: 'Sala de Estar' },
      { src: img3, alt: 'Habitaciones confortables para los residentes', title: 'Habitaciones' },
      { src: img4, alt: 'Vista del jardín principal de Mimina', title: 'Jardín Principal' },
      { src: img5, alt: 'Sala de estar para residentes', title: 'Sala de Estar' },
      { src: img6, alt: 'Habitaciones confortables para los residentes', title: 'Habitaciones' },
      { src: img7, alt: 'Habitaciones confortables para los residentes', title: 'Habitaciones' },
      { src: img8, alt: 'Habitaciones confortables para los residentes', title: 'Habitaciones' },
      { src: img9, alt: 'Habitaciones confortables para los residentes', title: 'Habitaciones' },
    ],
  },
  {
    id: 'galeria4',
    title: 'Cuidados intensivos',
    icon: 'fas fa-user-nurse',
    images: [
      { src: img1, alt: 'Vista del jardín principal de Mimina', title: 'Jardín Principal' },
      { src: img2, alt: 'Sala de estar para residentes', title: 'Sala de Estar' },
      { src: img3, alt: 'Habitaciones confortables para los residentes', title: 'Habitaciones' },
      { src: img4, alt: 'Vista del jardín principal de Mimina', title: 'Jardín Principal' },
      { src: img5, alt: 'Sala de estar para residentes', title: 'Sala de Estar' },
      { src: img6, alt: 'Habitaciones confortables para los residentes', title: 'Habitaciones' },
      { src: img7, alt: 'Habitaciones confortables para los residentes', title: 'Habitaciones' },
      { src: img8, alt: 'Habitaciones confortables para los residentes', title: 'Habitaciones' },
      { src: img9, alt: 'Habitaciones confortables para los residentes', title: 'Habitaciones' },
    ],
  },
  {
    id: 'galeria5',
    title: 'Espacios recreativos',
    icon: 'fas fa-users',
    images: [
      { src: img1, alt: 'Vista del jardín principal de Mimina', title: 'Jardín Principal' },
      { src: img2, alt: 'Sala de estar para residentes', title: 'Sala de Estar' },
      { src: img3, alt: 'Habitaciones confortables para los residentes', title: 'Habitaciones' },
      { src: img4, alt: 'Vista del jardín principal de Mimina', title: 'Jardín Principal' },
      { src: img5, alt: 'Sala de estar para residentes', title: 'Sala de Estar' },
      { src: img6, alt: 'Habitaciones confortables para los residentes', title: 'Habitaciones' },
      { src: img7, alt: 'Habitaciones confortables para los residentes', title: 'Habitaciones' },
      { src: img8, alt: 'Habitaciones confortables para los residentes', title: 'Habitaciones' },
      { src: img9, alt: 'Habitaciones confortables para los residentes', title: 'Habitaciones' },
    ],
  },
];

export default { galleries };

